module.exports = __webpack_public_path__ + "images/6bc7cf488f20f97f00d2606584110c1a.png";